import { Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

interface InlineEditingButtonProps {
    isEditing: boolean;
    setIsEditing: Dispatch<SetStateAction<boolean>>;
}

export default function InlineEditingButton({ isEditing, setIsEditing }: InlineEditingButtonProps) {
    return (
        <Button
            size="small"
            variant={isEditing ? "contained" : "outlined"}
            onClick={() => setIsEditing((prev) => !prev)}
            startIcon={<Edit />}
            sx={{
                color: isEditing ? "breakout.contrastText" : "breakout.main",
                borderColor: "breakout.main",
                backgroundColor: isEditing ? "breakout.main" : "transparent",
                '&:hover': {
                    borderColor: "breakout.light",
                    backgroundColor: isEditing ? "breakout.dark" : "transparent",
                },
            }}
        >
            {isEditing ? "Fertig" : "Bearbeiten"}
        </Button>
    )
}